import { useMutation } from 'react-query';

import {
  postInitiateRecoveryFactorSca,
  type PostInitiateRecoveryFactorScaInput,
} from 'modules/members/api/postInitiateRecoveryFactorSca';

export const useInitiateRecoveryFactorScaMutation = () => {
  return useMutation((input: PostInitiateRecoveryFactorScaInput) =>
    postInitiateRecoveryFactorSca(input),
  );
};
